export default "__VITE_ASSET__Bzoq1sBw__"